export const MODULE_NAME = "TABLE";